module.exports = __webpack_public_path__ + "static/media/bottlegarden_5.6cacb867.jpg";